/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Compose_SendingInputs */

const en_mail_compose_sending = /** @type {(inputs: Mail_Compose_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending… this may take a few minutes`)
};

const de_mail_compose_sending = /** @type {(inputs: Mail_Compose_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden… das kann einige Minuten dauern`)
};

/**
* | output |
* | --- |
* | "Sending… this may take a few minutes" |
*
* @param {Mail_Compose_SendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_sending = /** @type {((inputs?: Mail_Compose_SendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_SendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_sending(inputs)
	return en_mail_compose_sending(inputs)
});